import { __awaiter } from 'tslib';
import { IMEvent, InitResult } from '../../consts.js';
import { Logger } from '../../metrics/logger.js';
import { CommandMessage, CommandType } from '../../model/CommandMessage.js';
import { BaseProcessor } from './BaseProcessor.js';
import * as Long from 'long';
import { Participant } from '../../model/Participant.js';
import { ServiceIdentity } from '../RuntimeContext.js';

class CommandProcessor extends BaseProcessor {
    process(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (item.data.isCommandMsg) {
                item.needContinue = false;
                yield this.parseCommand(item.data);
            }
            return item;
        });
    }
    parseCommand(raw) {
        return __awaiter(this, void 0, void 0, function* () {
            const m = CommandMessage.fromMessage(raw);
            switch (m.contentObj.command_type) {
                case CommandType.DeleteConversation:
                    this.handleDeleteConversationCMD(m);
                    break;
                case CommandType.DeleteMessage:
                    this.handleDeleteMessageCMD(m);
                    break;
                case CommandType.MarkConversationRead:
                    this.handleMarkConversationRead(m);
                    break;
                case CommandType.SettingInfoUpdate:
                    yield this.handleUpdateSettingInfo(m);
                    break;
                case CommandType.CoreInfoUpdate:
                    yield this.handleUpdateCoreInfo(m);
                    break;
                case CommandType.ParticipantUpdate:
                    yield this.handleUpdateParticipant(m);
                    break;
            }
            this.resolve(ServiceIdentity.EventBus).emit(IMEvent.ReceiveCommandMessage, this, m);
        });
    }
    handleDeleteConversationCMD(m) {
        const { conversation_id } = m.contentObj;
        this.resolve(ServiceIdentity.ConversationManager).delete(conversation_id);
    }
    handleDeleteMessageCMD(m) {
        const { conversation_id, message_id } = m.contentObj;
        this.resolve(ServiceIdentity.MessageManager).delete(conversation_id, message_id.toString());
    }
    handleMarkConversationRead(m) {
        if (this.ctx.initResult === InitResult.Succeeded) {
            const { conversation_id, read_index } = m.contentObj;
            this.resolve(ServiceIdentity.ConversationManager).markRead(conversation_id, Long.fromValue(read_index));
        }
    }
    handleUpdateSettingInfo(m) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.ctx.initResult === InitResult.Succeeded) {
                const { conversation_version } = m.contentObj;
                const longConversationVersion = Long.fromValue(conversation_version !== null && conversation_version !== void 0 ? conversation_version : Long.MAX_VALUE);
                const local = this.resolve(ServiceIdentity.ConversationManager).getWithCreateLocal(m.conversationId, m.conversationShortId.toString(), m.conversationType);
                if (local.settingInfo.version.lte(longConversationVersion)) {
                    this.resolve(ServiceIdentity.ConversationManager).refresh(local);
                }
                else {
                    Logger.ctxWarn(this.ctx, 'ignore online update setting info cmd, local version: ', local.settingInfo.version.toString(), 'online: ', longConversationVersion.toString());
                }
            }
        });
    }
    handleUpdateCoreInfo(m) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.ctx.initResult === InitResult.Succeeded) {
                const { group_version } = m.contentObj;
                const longGroupVersion = Long.fromValue(group_version);
                const local = this.resolve(ServiceIdentity.ConversationManager).getWithCreateLocal(m.conversationId, m.conversationShortId.toString(), m.conversationType);
                if (local.coreInfo.version.lte(longGroupVersion)) {
                    this.resolve(ServiceIdentity.ConversationManager).refresh(local);
                }
                else {
                    Logger.ctxWarn(this.ctx, 'ignore online update core info cmd, local version: ', local.coreInfo.version.toString(), 'online: ', group_version.toString());
                }
            }
        });
    }
    handleUpdateParticipant(m) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.ctx.initResult === InitResult.Succeeded) {
                const { added_participant, modified_participant, removed_participant } = m.contentObj;
                if ((added_participant === null || added_participant === void 0 ? void 0 : added_participant.length) > 0) {
                    // 添加群成员
                    const addedParticipant = added_participant.map(String);
                    const participants = [];
                    addedParticipant.forEach(userId => {
                        const fakeP = Participant.fakeParticipant(this.ctx, userId, {
                            type: m.conversationType,
                            id: m.conversationId
                        });
                        participants.push(fakeP);
                    });
                    this.resolve(ServiceIdentity.ParticipantManager).addBatch(m.conversationId, participants);
                }
                if ((modified_participant === null || modified_participant === void 0 ? void 0 : modified_participant.length) > 0) {
                    // 修改群成员
                    const conv = this.resolve(ServiceIdentity.ConversationManager).get(m.conversationId);
                    const modifiedParticipant = modified_participant.map(String);
                    void this.resolve(ServiceIdentity.ParticipantManager).updateWithUserIdAsync(conv, modifiedParticipant);
                }
                if ((removed_participant === null || removed_participant === void 0 ? void 0 : removed_participant.length) > 0) {
                    const removedParticipant = removed_participant.map(String);
                    // 踢出会话
                    if (removedParticipant.includes(this.ctx.option.userId)) {
                        this.resolve(ServiceIdentity.ConversationManager).leave(m.conversationId);
                    }
                    // 移除群成员
                    this.resolve(ServiceIdentity.ParticipantManager).delete(m.conversationId, removedParticipant);
                }
            }
        });
    }
}

export { CommandProcessor };
//# sourceMappingURL=CommandProcessor.js.map
